/**
 * Returns true.
 *
 * @returns {boolean} true.
 * @example
 * stubTrue() // Returns true
 */
export function stubTrue(): true;

/**
 * Returns true.
 *
 * @returns {boolean} true.
 * @example
 * stubTrue() // Returns true
 */
export function stubTrue(): true;

export function stubTrue(): true {
  return true;
}
